import React, { useState, useImperativeHandle, useContext, useEffect } from 'react';
import TContext from '../context'
import { Input, TextArea, Tabs, Range, Infiniteloading, Toast } from '@nutui/nutui-react';
import http from '../../../lib/http'
import * as apis from '../../../lib/apis'
import { cloneDeep } from 'lodash';
import * as THREE from 'three';
import { ColorPicker } from 'antd';
const textColor = ["#FFFFFF", "#000000", "#4D4D4D", "#808080", "#B3B3B3", "#E6E6E6", "#3b2722", "#5a3f34", "#9f877d", "#d4cbc4", "#556c78", "#90a0ad", "#ced6da", "#f7e6b0", "#f7f4c3", "#f1f5e6", "#e3f0fb", "#eae6f3", "#f4dae2", "#fad3cb", "#205d62", "#3a9284", "#8cba53", "#4d6d45", "#b7d332", "#a5cea3", "#84c4ba", "#a3bbe1", "#9ca1d0", "#4b9ed8", "#1d5192", "#1e296e", "#3f4fa0", "#432082", "#584096", "#853b92", "#831e4c", "#e60012", "#e24c3d", "#f188ac", "#f69796", "#f38435", "#e4ad35", "#edd481", "#f6f19d", "#f0cb59", "#be8a2f", "#2c2929"]

interface Props {
    action?: any,
    onPaneKeyChange?: (paneKey: number) => void;
    preloadedData?: any;
    dataLoading?: boolean;
}

export interface Action {
    setShow?: (isShow: boolean) => void;
    editShow?: () => void; //编辑的显示
    setTitle?: (s: string) => void; //设置title文字
    confirm?: () => boolean;
    cancel?: () => void;
    getPaneKey?: () => number | undefined;
}

export const Height = 580

var previewTextObject: any = null
var tempJson: any = null

const Index = (props: Props) => {
    const {
        preloadedData,
    } = props;
    const [show, setInnerShow] = useState(false)
    const [currentColor, setCurrentColor] = useState<string>(textColor[1])
    const [title, setTitle] = useState<string>("文字设置")
    const [swiperClient, setSwiperClient] = useState<any>()
    const [paneKey, setPaneKey] = useState<number>()
    const [page, setPage] = useState<number>()
    const [colorPalette, setColorPalette] = useState<any>({ list: [], count: 0 })
    const [isVisible, setIsVisible] = useState(false) // 添加可见状态
    const tc = useContext(TContext)
    const [selectedColor, setSelectedColor] = useState<string | null>(null);
    const [hasInitialized, setHasInitialized] = useState(false);
    useImperativeHandle(props.action, (): Action => ({
        setShow,
        confirm,
        cancel,
        setTitle,
        editShow,
        getPaneKey: () => paneKey,
    }));
    useEffect(() => {
        if (preloadedData && !hasInitialized) {
            setColorPalette({
                list: preloadedData.list || [],
                count: preloadedData.count || 0
            });
            setPage(preloadedData.currentPage || 1);
            setHasInitialized(true);
        } else {

        }
    }, [preloadedData, hasInitialized]);
    const loadList = async (pageNum: number) => {
        try {
            const list: any = await http.get(apis.DESIGNER_COLOR, {
                params: {
                    page: pageNum,
                    limit: 80
                }
            })
            if (pageNum === 1) {
                setColorPalette(list);
                return {
                    list: list.list,
                    count: list.count
                };
            } else {
                let cpList: any = cloneDeep(colorPalette);
                cpList.count = list.count;
                cpList.list = [...cpList.list, ...list.list];
                setColorPalette(cpList);
                return {
                    list: cpList.list,
                    count: cpList.count
                };
            }
        } catch (error) {

        }
    }

    //加载更多
    const onLoadMore = async (done: () => void) => {
        const currentPage = page || 1;
        const nextPage = currentPage + 1;

        try {
            await loadList(nextPage);
            setPage(nextPage);
        } catch (error) {
            console.error('加载更多失败:', error);
            setPage(prev => (prev || 1) - 1);
        }
        done();
    };

    const editShow = () => {
        previewTextObject = tc.curActivityObject;
        if (previewTextObject.type !== "text") {
            return;
        }

        tempJson = tc?.fabricClient?.getJsonData();
        setPaneKey(0);
        setInnerShow(true);

        let colorIndex = textColor.findIndex(v => v === previewTextObject.fill);
        if (colorIndex === -1) {
            colorIndex = 0;
        }
        swiperClient?.slideTo(colorIndex);
    };

    const setShow = async (isShow: boolean) => {
        setInnerShow(isShow)
        if (isShow) {
            setIsVisible(true)
            tempJson = tc?.fabricClient?.getJsonData()
            const defaultColor = textColor[1]
            setPaneKey(0)

            tc.curCanvasClient?.discardActiveObject()
            tc.curCanvasClient?.getFabricCanvas().renderAll()
            setCurrentColor(defaultColor)
            swiperClient?.slideTo(textColor.findIndex(v => v === defaultColor))
            // 只有在没有预加载数据且当前没有数据时才加载第一页
            if (!hasInitialized && (!colorPalette.list || colorPalette.list.length === 0)) {
                Toast.loading(t("加载颜色"), {
                    cover: true,
                    closeOnClickOverlay: false,
                    duration: 0
                });
                const colorPaletteData = await loadList(1);
                setColorPalette(colorPaletteData);
                setPage(1);
                Toast.hide();
            }

            // const colorPalette = await loadList(1)
            // setColorPalette(colorPalette)
            // setPage(1)

            Toast.hide()
        } else {
            setTimeout(() => setIsVisible(false), 350)
        }
    }
    // //取消
    const cancel = () => {
        previewTextObject = null
        setInnerShow(false)
        try {
            const ips: any = document.getElementsByClassName("nut-textarea__textarea")
            for (let i = 0; i < ips.length; i++) {
                ips[i].blur();
            }
        } catch (error) {

        }
    }

    //确认
    const confirm = () => {
        if (!previewTextObject) {
            return false
        }
        tc.curCanvasClient.getFabricCanvas().renderAll()

        try {
            const ips: any = document.getElementsByClassName("nut-textarea__textarea")
            for (let i = 0; i < ips.length; i++) {
                ips[i].blur();
            }
        } catch (error) {

        }
        return true
    }


    const handleColorSelect = (color: string) => {
        console.log(tc.notEmptyCodes)
        setSelectedColor(color);
        if (tc.curCanvasClient && tc.curCutpartCode) {
            try {
                // 应用颜色到Fabric.js对象
                applyColorToFabricObject(tc.curCanvasClient, color, tc.curCutpartCode);
            } catch (error) {
                console.error('修改颜色时出错:', error);
            }
        }

    };
    const applyColorToFabricObject = (canvasClient: any, color: string, cutpartCode: string) => {
        const canvas = canvasClient.getFabricCanvas();
        const rgbaColor = normalizeToRgba(color, 0); // 30%透明度
        canvas.set('backgroundColor', rgbaColor);
        canvas.renderAll();

        // 修改设计材质的颜色
        tc.threeClient.scene.traverse((child: any) => {
            // child.material.color = new THREE.Color(color);
            if (child.isMesh && child.material) {
                if (child?.material) {
                    if (child?.material?.name === cutpartCode) {
                        // 截取颜色的十六进制值
                        child.material.color = new THREE.Color(color);
                    } else if (child?.material?.name === "" && child?.name === cutpartCode) {
                        child.material.color = new THREE.Color(color);
                    }
                }
            }
            // if (!child.material) {
            //     // 创建新的基础材质
            //     child.material = new THREE.MeshBasicMaterial({
            //         color: new THREE.Color(color),
            //         transparent: true,
            //         opacity: 0.8
            //     });
            //     console.log(`为 ${child.name} 创建了新材质`);
            // } else {
            //     // 已有材质，直接设置颜色
            //     child.material.color = new THREE.Color(color);
            //     child.material.needsUpdate = true;
            // }
        });

        tc?.markAsChanged?.();
    };
    // 统一颜色处理函数
    function normalizeToRgba(color: string, alpha: number): string {
        // 十六进制格式
        if (color.startsWith('#')) {
            return hexToRgba(color, alpha);
        }
        // rgb 格式（没有透明度）
        if (color.startsWith('rgb(')) {
            return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
        }

        // rgba 格式（已有透明度）
        if (color.startsWith('rgba(')) {
            // 替换现有的透明度
            return color.replace(/rgba\(([^,]+),([^,]+),([^,]+),([^)]+)\)/, `rgba($1, $2, $3, ${alpha})`);
        }

        // 默认返回黑色
        console.warn('无法识别的颜色格式，使用默认颜色:', color);
        return `rgba(0, 0, 0, ${alpha})`;
    }

    function hexToRgba(hex: string, alpha: number) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    return (

        <div id="scroll" style={{
            height: 'calc(100vh - 80px)',
            overflowY: "auto",
            overflowX: "hidden",
            padding: "0 5px",
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        }}>
            <div style={{ padding: '16px' }}>

                <ColorPicker
                    value={selectedColor || ''}
                    defaultValue={selectedColor}
                    onChange={(color, cssColor) => {
                        setSelectedColor(cssColor);
                        handleColorSelect(cssColor);
                    }}
                />
            </div>
            <Infiniteloading
                loadIcon=""
                containerId="scroll"
                useWindow={false}
                hasMore={colorPalette?.count !== colorPalette?.list?.length}
                onLoadMore={onLoadMore}
                loadMoreTxt={`${colorPalette?.count !== colorPalette?.list?.length ? t('加载更多') : t('没有更多数据了')}`}
                style={{ paddingBottom: 12 }}
            >
                {/* 颜色网格 */}
                <div>
                    {(colorPalette?.list as any)?.map((category: any, categoryIndex: number) => (
                        <div key={category.id || categoryIndex}>
                            {/* 分类标题 */}
                            <div style={{
                                padding: '8px',
                                borderRadius: '4px',
                            }}>
                            </div>

                            {/* 颜色网格 */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '16px',
                                padding: '0 16px 16px 16px',
                                borderBottom: '1px solid #f0f0f0',
                            }}>
                                {category.colors.map((colorItem: any, colorIndex: number) => (
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }} key={colorItem.id || `${categoryIndex}-${colorIndex}`}>
                                        <div

                                            onClick={() => handleColorSelect(colorItem.code)}
                                            style={{
                                                width: '100%',
                                                height: '60px',
                                                backgroundColor: colorItem.code,
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                outline: selectedColor === colorItem.code ? '2px solid #1890ff' : 'none',
                                                outlineOffset: selectedColor === colorItem.code ? '-2px' : '0',
                                                transition: 'outline 0.2s ease'
                                            }}
                                            title={`${colorItem.name} - ${colorItem.code}`}
                                        >
                                        </div>
                                        <div style={{
                                            marginTop: '8px',
                                        }}>{colorItem.code}</div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    ))}
                </div>
            </Infiniteloading>
        </div>

    )
}

export default Index
